// extracted by mini-css-extract-plugin
module.exports = {"container":"antd-pro-components-form-widgets-msg-code-index-container","rt":"antd-pro-components-form-widgets-msg-code-index-rt"};